import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { ILocation } from "src/domain/entities"
import { locationDeleteService } from "src/domain/services/location/locationDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	location: ILocation
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const LocationDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	location,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleLocationDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await locationDeleteService({ id: location.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [location, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Location: ${location.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleLocationDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
